export default __webpack_public_path__ + "static/media/checkbox-round.0042e04e.svg";